import React, { FC } from "react"
import { Link } from "gatsby"
import { container, content } from "./styles"
/** @jsx jsx */
import { replaceAll } from "../../utils/helpers"
import { jsx } from "@emotion/react"

const ROUTE = process.env.NODE_ENV === "development" ? "" : "/legal"

interface SideMenuProps {
  sideBarList?: { path: string; text: string }[]
  path: string
}

/**
 * Terms of use side header
 *
 * @param {*} { sideBarList = [] }
 * @returns
 */
const SideMenu: FC<SideMenuProps> = ({ sideBarList = [], path }) => {
  return (
    <div css={container}>
      {sideBarList.map((option, index) => {
        return (
          <Link
            to={option.path}
            role="button"
            key={index}
            css={content(
              replaceAll(path, "/", "") ===
                replaceAll(`${ROUTE}${option.path}`, "/", "")
            )}
          >
            {option.text}
          </Link>
        )
      })}
    </div>
  )
}

export default SideMenu
